(() => {
  const alignedDesktop = window.matchMedia('(min-width: 1200px)');
  const section = document.querySelector('.shopify-section-main-product');
  if (!section) return;

  const body = document.body;
  const form = section.querySelector('.product-info-detail');
  const MIN_H = 300;
  const MAX_H = 900;
  const MIN_DELTA = 4;
  let frame = 0;
  let debounceTimer = 0;
  let lastHeight = 0;

  /* Primary anchor = Shop with Confidence row (.box-item-wrap). Fallback
     blocks are used only when that row is missing on a given PDP. */
  const ANCHOR = '.box-item-wrap';
  const FALLBACK_BLOCKS = [
    '.product-header-infor',
    '.product-sticky-mobile',
    '.quick-specs-block',
    '.product-collection-banner',
  ];

  function elements() {
    return {
      hero: section.querySelector(
        '.main-gallery .tns-slide-active .image__style, ' +
        '.main-gallery .media-item:not(.tns-slide-cloned) .image__style, ' +
        '.main-gallery .product-no-image .image__style'
      ),
    };
  }

  function reset() {
    body.style.removeProperty('--pdp-media-h');
    body.style.removeProperty('--pdp-gallery-mt');
    delete body.dataset.pdpMediaHBoot;
    lastHeight = 0;
  }

  function cssZoom() {
    const z = parseFloat(window.getComputedStyle(document.documentElement).zoom);
    return Number.isFinite(z) && z > 0 ? z : 1;
  }

  function visibleBottom(el) {
    if (!el) return null;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return null;
    const rect = el.getBoundingClientRect();
    if (rect.height <= 0) return null;
    return rect.bottom;
  }

  function measureHeroHeight() {
    const mediaColumn = section.querySelector('.product-media-column');
    const info = section.querySelector('.product-info-detail');
    if (!mediaColumn || !info) return null;

    const columnTop = mediaColumn.getBoundingClientRect().top;
    let visualH = 0;

    const anchorBottom = visibleBottom(info.querySelector(ANCHOR));
    if (anchorBottom != null && anchorBottom > columnTop) {
      visualH = anchorBottom - columnTop;
    } else {
      let fallbackBottom = columnTop;
      for (const selector of FALLBACK_BLOCKS) {
        const bottom = visibleBottom(info.querySelector(selector));
        if (bottom != null) fallbackBottom = Math.max(fallbackBottom, bottom);
      }
      if (fallbackBottom <= columnTop) {
        fallbackBottom = info.getBoundingClientRect().bottom;
      }
      visualH = fallbackBottom - columnTop;
    }

    if (!(visualH > 0)) return null;

    return Math.ceil(visualH / cssZoom());
  }

  function sync() {
    frame = 0;

    if (!alignedDesktop.matches) {
      reset();
      return;
    }

    const { hero } = elements();
    if (!hero) return;

    /* Keep the boot value in place while measuring the independent anchor. */
    const measured = measureHeroHeight();
    if (measured == null) return;

    const targetHeight = Math.max(MIN_H, Math.min(MAX_H, measured));
    /* Honor inline boot measure from main-product-page.liquid -- skip the
       first deferred-JS rewrite when it matches within tolerance. */
    if (!lastHeight) {
      const boot = parseInt(body.dataset.pdpMediaHBoot || '', 10);
      if (boot && Math.abs(targetHeight - boot) < MIN_DELTA) {
        lastHeight = boot;
        return;
      }
    }
    if (lastHeight && Math.abs(targetHeight - lastHeight) < MIN_DELTA) return;

    lastHeight = targetHeight;
    body.style.setProperty('--pdp-media-h', `${targetHeight}px`);
    body.style.setProperty('--pdp-gallery-mt', '0px');
  }

  function schedule() {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(sync);
  }

  function scheduleDebounced() {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(schedule, 120);
  }

  /* Resync only on load, viewport resize, or a variant change. Waiting for
     variant updates also lets their heading and warranty copy settle. */
  if (form) {
    form.addEventListener('change', (event) => {
      if (!event.target.classList.contains('js-variant-change')) return;
      scheduleDebounced();
    });
  }

  schedule();
  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('resize', scheduleDebounced, { passive: true });
})();
